import { render, staticRenderFns } from "./file.vue?vue&type=template&id=0f66ba1d"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"
import style0 from "./file.vue?vue&type=style&index=0&id=0f66ba1d&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f66ba1d')) {
      api.createRecord('0f66ba1d', component.options)
    } else {
      api.reload('0f66ba1d', component.options)
    }
    module.hot.accept("./file.vue?vue&type=template&id=0f66ba1d", function () {
      api.rerender('0f66ba1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploader/file.vue"
export default component.exports